<template>
  <div class="PopupOverlay"/>
</template>

<script>
export default {
  name: 'PopupOverlay'
}
</script>

<style>
.PopupOverlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
